/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Spinner from "../components/spinner";

const Policy = ({ addCategory, costProject, handleBack, handleNext }) => {
  const projectId = localStorage.getItem("projectId" || "");
  const clientId = localStorage.getItem("clientId" || "");
  const ownerId = localStorage.getItem("OwnerId" || "");
  const location = useLocation();
  const { state } = location;

  const years = [2019, 2020, 2022];
  const [isLoading, setIsLoading] = useState(false);
  const [project, setProject] = useState({});
  const [client, setClient] = useState({});
  const [owner, setOwner] = useState();
  const [companySize, setCompanySize] = useState("");
  const [policy2019Id, setPolicy2019Id] = useState();
  const [policy2020Id, setPolicy2020Id] = useState();
  const [policy2022Id, setPolicy2022Id] = useState();

  const [elegible, setElegible] = useState("");
  const [interestRate, setInterestRest] = useState("");
  const [yearOfExpension, setYearOfExpension] = useState("");
  const [unit, setUnit] = useState("");
  const [capital, setCapital] = useState("");

  const [elegible20, setElegible20] = useState("");
  const [interestRate20, setInterestRest20] = useState("");
  const [yearOfExpension20, setYearOfExpension20] = useState("");
  const [unit20, setUnit20] = useState("");
  const [capital20, setCapital20] = useState("");

  const [elegible22, setElegible22] = useState("");
  const [interestRate22, setInterestRest22] = useState("");
  const [yearOfExpension22, setYearOfExpension22] = useState("");
  const [capital22, setCapital22] = useState("");
  const [displayYear, setDisplayYear] = useState("");

  const [cgtmse19, setCgtmse19] = useState(0);
  const [sgst19, setSgst19] = useState(0);
  const [epf19, setEpf19] = useState(0);

  const [cgtmse20, setCgtmse20] = useState(0);
  const [sgst20, setSgst20] = useState(0);
  const [epf20, setEpf20] = useState(0);

  const [cgtmse22, setCgtmse22] = useState(0);
  const [sgst22, setSgst22] = useState(0);
  const [epf22, setEpf22] = useState(0);

  const [apply19, setApply19] = useState(0);
  const [apply20, setApply20] = useState(0);
  const [apply22, setApply22] = useState(0);
  const [policy2019Year, setPolicy2019Year] = useState();
  const [policy2020Year, setPolicy2020Year] = useState();
  const [policy2022Year, setPolicy2022Year] = useState();

  const handleChange = async (e, fieldName) => {
    let data2019 = [];
    let data2020 = [];
    let data2022 = [];

    if (fieldName === "cgtmse19") {
      setCgtmse19((prevState) => (prevState === 0 ? 1 : 0));
      data2019.push({
        year: 2019,
        cgtmse: e.target.checked ? 1 : 0,
        sgst: sgst19,
        epf: epf19,
        apply: apply19,
        projectId: projectId || state?.projectId,
      });
    } else if (fieldName === "sgst19") {
      setSgst19((prevState) => (prevState === 0 ? 1 : 0));
      data2019.push({
        year: 2019,
        cgtmse: cgtmse19,
        sgst: e.target.checked ? 1 : 0,
        epf: epf19,
        apply: apply19,
        projectId: projectId || state?.projectId,
      });
    } else if (fieldName === "epf19") {
      setEpf19((prevState) => (prevState === 0 ? 1 : 0));
      data2019.push({
        year: 2019,
        cgtmse: cgtmse19,
        sgst: sgst19,
        epf: e.target.checked ? 1 : 0,
        apply: apply19,
        projectId: projectId || state?.projectId,
      });
    } else if (fieldName === "apply19") {
      setApply19((prevState) => (prevState === 0 ? 1 : 0));
      data2019.push({
        year: 2019,
        cgtmse: cgtmse19,
        sgst: sgst19,
        epf: epf19,
        apply: e.target.checked ? 1 : 0,
        projectId: projectId || state?.projectId,
        capital:  e.target.checked === true ? capital : ""
      });
    } else {
      console.log("----");
    }
    if (fieldName === "cgtmse20") {
      setCgtmse20((prevState) => (prevState === 0 ? 1 : 0));
      data2020.push({
        year: 2020,
        cgtmse: e.target.checked ? 1 : 0,
        sgst: sgst20,
        epf: epf20,
        apply: apply20,
        projectId: projectId || state?.projectId,
      });
    } else if (fieldName === "sgst20") {
      setSgst20((prevState) => (prevState === 0 ? 1 : 0));
      data2020.push({
        year: 2020,
        cgtmse: cgtmse20,
        sgst: e.target.checked ? 1 : 0,
        epf: epf20,
        apply: apply20,
        projectId: projectId || state?.projectId,
      });
    } else if (fieldName === "epf20") {
      setEpf20((prevState) => (prevState === 0 ? 1 : 0));
      data2020.push({
        year: 2020,
        cgtmse: cgtmse20,
        sgst: sgst20,
        epf: e.target.checked ? 1 : 0,
        apply: apply20,
        projectId: projectId || state?.projectId,
      });
    } else if (fieldName === "apply20") {
      console.log('e.target.checked ', e.target.checked )
      setApply20((prevState) => (prevState === 0 ? 1 : 0));
      data2020.push({
        year: 2020,
        cgtmse: cgtmse20,
        sgst: sgst20,
        epf: epf20,
        apply: e.target.checked ? 1 : 0,
        projectId: projectId || state?.projectId,
        capital: e.target.checked === true ? capital20 : ""
      });
    } else {
      console.log("----");
    }
    if (fieldName === "cgtmse22") {
      setCgtmse22((prevState) => (prevState === 0 ? 1 : 0));
      data2022.push({
        year: 2022,
        cgtmse: e.target.checked ? 1 : 0,
        sgst: sgst22,
        epf: epf22,
        apply: apply22,
        projectId: projectId || state?.projectId,
      });
    } else if (fieldName === "sgst22") {
      setSgst22((prevState) => (prevState === 0 ? 1 : 0));
      data2022.push({
        year: 2022,
        cgtmse: cgtmse22,
        sgst: e.target.checked ? 1 : 0,
        epf: epf22,
        apply: apply22,
        projectId: projectId || state?.projectId,
      });
    } else if (fieldName === "epf22") {
      setEpf22((prevState) => (prevState === 0 ? 1 : 0));
      data2022.push({
        year: 2022,
        cgtmse: cgtmse22,
        sgst: sgst22,
        epf: e.target.checked ? 1 : 0,
        apply: apply22,
        projectId: projectId || state?.projectId,
      });
    } else if (fieldName === "apply22") {
      setApply22((prevState) => (prevState === 0 ? 1 : 0));
      data2022.push({
        year: 2022,
        cgtmse: cgtmse22,
        sgst: sgst22,
        epf: epf22,
        apply: e.target.checked ? 1 : 0,
        projectId: projectId || state?.projectId,
        capital: e.target.checked === true ? capital22 : ""
      });
    } else {
      console.log("----");
    }

    try {
      if (
        policy2019Id &&
        data2019.length !== 0 &&
        policy2019Year === years[0]
      ) {
        try {
          setIsLoading(true);
          await axios.put(
            `${process.env.REACT_APP_API_URL}/update-policy/${policy2019Id}`,
            data2019,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("signIn")}`,
              },
            }
          );
        } catch (error) {
          console.error("Error submitting policy data:", error);
        } finally {
          setIsLoading(false);
        }
      }
      if (
        policy2020Id &&
        data2020.length !== 0 &&
        policy2020Year === years[1]
      ) {
        try {
          setIsLoading(true);
          await axios.put(
            `${process.env.REACT_APP_API_URL}/update-policy/${policy2020Id}`,
            data2020,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("signIn")}`,
              },
            }
          );
        } catch (error) {
          console.error("Error submitting policy data:", error);
        } finally {
          setIsLoading(false);
        }
      }

      if (
        policy2022Id &&
        data2022.length !== 0 &&
        data2022 &&
        policy2022Year === years[2]
      ) {
        try {
          setIsLoading(true);
          await axios.put(
            `${process.env.REACT_APP_API_URL}/update-policy/${policy2022Id}`,
            data2022,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("signIn")}`,
              },
            });
        } catch (error) {
          console.error("Error submitting policy data:", error);
        } finally {
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.error("Error updating policies", error);
    }
  };

  const fetchData = async (url) => {
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("signIn")}`,
        },
      });
      return response.data.result;
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  };

  const handleProjectData = async () => {
    try {
      const projectRes = await fetchData(
        `${process.env.REACT_APP_API_URL}/get-project-byId/${
          projectId || state?.projectId || null
        }`
      );
      setProject(projectRes[0]);

      const clientRes = await fetchData(
        `${process.env.REACT_APP_API_URL}/get-client-byId/${
          clientId || state?.clientId || null
        }`
      );
      if (clientRes.length > 0) {
        setClient(clientRes[0]);
      }

      const ownerIdArray = JSON.parse(ownerId) || [];
      const ownerDataArray = await Promise.all(
        ownerIdArray.map((id) =>
          fetchData(`${process.env.REACT_APP_API_URL}/get-owner-byId/${id}`)
        )
      );
      const owners = ownerDataArray.flat();
      setOwner(owners);
    } catch (error) {
      console.error("Error handling project data:", error);
    }
  };

  const getPolicyData = async () => {
    if (projectId || state?.projectId) {
      const Response = await axios.get(
        `${process.env.REACT_APP_API_URL}/get-policy`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("signIn")}`,
          },
        }
      );
      console.log('Response', Response)
      const policyData =
        Response.data.result &&
        Response.data.result.filter(
          (val) => val.projectId === JSON?.parse(projectId || state?.projectId)
        );
      if (policyData && policyData.length > 0) {
        const policy = policyData.map((value) => {
          const foundPolicy19 = policyData.find(
            (value) => value.year === years[0]
          );
          const foundPolicy20 = policyData.find(
            (value) => value.year === years[1]
          );
          const foundPolicy22 = policyData.find(
            (value) => value.year === years[2]
          );
          if (foundPolicy19) {
            setApply19(foundPolicy19.apply);
            setCgtmse19(foundPolicy19.cgtmse);
            setSgst19(foundPolicy19.sgst);
            setEpf19(foundPolicy19.epf);
            setPolicy2019Year(foundPolicy19.year);
            setPolicy2019Id(foundPolicy19?.id);
          }
          if (foundPolicy20) {
            setApply20(foundPolicy20.apply);
            setCgtmse20(foundPolicy20.cgtmse);
            setSgst20(foundPolicy20.sgst);
            setEpf20(foundPolicy20.epf);
            setPolicy2020Year(foundPolicy20.year);
            setPolicy2020Id(foundPolicy20?.id);
          }
          if (foundPolicy22) {
            setApply22(foundPolicy22.apply);
            setCgtmse22(foundPolicy22.cgtmse);
            setSgst22(foundPolicy22.sgst);
            setEpf22(foundPolicy22.epf);
            setPolicy2022Year(foundPolicy22.year);
            setPolicy2022Id(foundPolicy22?.id);
          }
        });
        return policy;
      } else {
        console.log("No records available.");
      }
    }
  };
  const calculateAge = (dob) => {
    const dobDate = new Date(dob);
    const currentDate = new Date();

    const yearDiff = currentDate.getFullYear() - dobDate.getFullYear();

    if (
      currentDate.getMonth() < dobDate.getMonth() ||
      (currentDate.getMonth() === dobDate.getMonth() &&
        currentDate.getDate() < dobDate.getDate())
    ) {
      return yearDiff - 1;
    }
    return yearDiff;
  };

  const ownerAges = owner && owner.map((val) => calculateAge(val.dob));
  useEffect(() => {
    handleProjectData();
    getPolicyData();
  }, [
    projectId,
    clientId,
    ownerId,
    state?.projectId,
    state?.clientId,
    policy2020Id,
    addCategory
  ]);

  useEffect(() => {
    getPolicyData();
  }, [
    apply19,
    apply20,
    apply22,
    cgtmse19,
    sgst19,
    epf19,
    cgtmse20,
    sgst20,
    epf20,
    cgtmse22,
    sgst22,
    epf22,
    projectId,
    state,
    addCategory
  ]);

  useEffect(() => {
    if (project?.costProject < 10000000) {
      setCompanySize("micro");
    } else if (
      project?.costProject >= 10000000 &&
      project?.costProject <= 10000000
    ) {
      setCompanySize("small");
    } else if (
      project?.costProject >= 10000000 &&
      project?.costProject <= 50000000
    ) {
      setCompanySize("medium");
    } else if (project?.costProject > 50000000) {
      setCompanySize("large");
    }
  }, [project]);
  useEffect(() => {
    if (years[0]) {
      if (project?.noOfExpension <= 3 && project?.projectType === "existing") {
        const preProAmount = parseFloat(project.preProjectCost) * 0.25;
        const totalAmount =
          parseFloat(project.promoterCont) + parseFloat(project.loanAmt);
        if (totalAmount > preProAmount) {
          setElegible("Yes");
        } else {
          setElegible("No");
        }
      } else {
        setElegible("No");
      }
      if (project?.projectType === "new") {
        setElegible20("Yes");
      }

      if (
        project &&
        (project?.projectType === "new" || project?.projectType === "expension")
      ) {
        setYearOfExpension("5 Year");
        if (companySize === "large") {
          if (client?.noOfEmploye <= 100) {
            setInterestRest("4%");
          } else if (client?.noOfEmploye <= 200) {
            setInterestRest("4.5%");
          } else if (client?.noOfEmploye <= 500) {
            setInterestRest("5%");
          } else if (client?.noOfEmploye > 500) {
            setInterestRest("6%");
          }
        }
        if (
          companySize === "medium" ||
          companySize === "micro" ||
          companySize === "small"
        ) {
          setInterestRest("6%");
        }
        if (client.electricityConn !== "") {
          if (project.proMachineType === "weaving") {
            if (client.eleConnType === "LT") {
              setUnit("3 Rs/Unit");
            } else {
              setUnit("2 Rs/Unit");
            }
          } else {
            setUnit("2 Rs/Unit");
          }
        }
      } else {
        setInterestRest("");
        setYearOfExpension("");
        setUnit("");
        setCapital("");
      }
    }
    const gender = owner && owner.map((val) => val.gender);
    const physicallyHand = owner && owner.map((val) => val.physicallyHand);

    if (years[1]) {
      if (project?.noOfExpension === 2 && project?.projectType === "expension") {
        const preProAmount = parseFloat(project?.preProjectCost) * 0.5;
        const totalAmount =
          parseFloat(project?.promoterCont) + parseFloat(project?.loanAmt);
        if (totalAmount > preProAmount) {
          setElegible20("Yes");
        } else {
          setElegible20("No");
        }
      } else {
        setElegible20("No");
      }
      if (project?.projectType === "new") {
        setElegible20("Yes");
      }
      if (
        client.typeOfServices === "manufacturing" ||
        client.typeOfServices === "services"
      ) {
        if (
          companySize === "medium" ||
          companySize === "micro" ||
          companySize === "small"
        ) {
          ownerAges?.forEach((age, index) => {
            if (age < 35) {
              console.log('age', age)
              if (client.addCategory === "category_1") {
                setInterestRest20(`${7 + 1}%`);
                setCapital20("25%");
                setYearOfExpension20("5 Year");
              } else if (client.addCategory === "category_2") {
                setInterestRest20(`${6 + 1}%`);
                setCapital20("20%");
                setYearOfExpension20("5 Year");
              } else if (client.addCategory === "category_3") {
                setInterestRest20(`${5 + 1}%`);
                setCapital20("10%");
                setYearOfExpension20("5 Year");
              }
            } else if (
              gender &&
              gender.includes &&
              gender.includes("female") &&
              physicallyHand &&
              physicallyHand.includes &&
              physicallyHand.includes(1)
            ) {
              if (
                companySize === "medium" ||
                companySize === "micro" ||
                companySize === "small"
              ) {
                if (client.addCategory === "category_1") {
                  setCapital20("25%");
                  setInterestRest20(`${7 + 1}%`);
                  setYearOfExpension20("5 Year");
                } else if (client.addCategory === "category_2") {
                  setCapital20("20%");
                  setInterestRest20(`${6 + 1}%`);
                  setYearOfExpension20("5 Year");
                } else if (client.addCategory === "category_3") {
                  setInterestRest20(`${5 + 1}%`);
                  setCapital20("10%");
                  setYearOfExpension20("5 Year");
                }
              }
            } else {
              if (client.addCategory === "category_1") {
                setCapital20("25%");
                setInterestRest20("7%");
                setYearOfExpension20("5 Year");
              } else if (client.addCategory === "category_2") {
                setInterestRest20("6%");
                setCapital20("20%");
                setYearOfExpension20("5 Year");
              } else if (client.addCategory === "category_3") {
                setInterestRest20("5%");
                setCapital20("10%");
                setYearOfExpension20("5 Year");
              }
            }
          });
        }
      } else {
        setInterestRest20("");
        setYearOfExpension20("");
        setUnit20("");
        setCapital20("");
      }
    }

    if (years[2]) {
      if (project?.projectType === "new") {
        setElegible20("Yes");
      }
      // if (companySize === "large") {
      //   if (client?.addCategory === "category_1") {
      //     setInterestRest22(`100%`);
      //     setDisplayYear("10 Year");
      //   } else if (client?.addCategory === "category_2") {
      //     setInterestRest22(`90%`);
      //     setDisplayYear("10 Year");
      //   } else if (client?.addCategory === "category_3") {
      //     setInterestRest22(`80%`);
      //     setDisplayYear("10 Year");
      //   } else {
      //     setInterestRest22(``);
      //     setDisplayYear("");
      //   }
      // }

      if (project?.noOfExpension === 2 && project?.projectType === "expension") {
        const preProAmount = parseFloat(project?.preProjectCost) * 0.5;
        const totalAmount =
          parseFloat(project?.promoterCont) + parseFloat(project?.loanAmt);
        if (totalAmount > preProAmount) {
          setElegible22("Yes");
        } else {
          setElegible22("No");
        }
      } else {
        setElegible22("No");
      }
      // if (companySize === "medium") {
        ownerAges?.forEach((age, index) => {
          if (age <= 35) {
          //   if (client.addCategory === "category_1") {
          //     setCapital22("25%");
          //     setInterestRest22(`7%`);
           //    setYearOfExpension22("5 Year");
          //   } else if (client.addCategory === "category_2") {
          //     setCapital22("20%");
              setInterestRest22(`${6 + 1}%`);
              setYearOfExpension22("5 Year");
          //   } else if (client.addCategory === "category_3") {
          //     setInterestRest22(`${5 + 1}%`);
          //     setCapital22("10%");
          //     setYearOfExpension22("5 Year");
          //   }
          }else if (
            gender &&
            gender.includes &&
            gender.includes("female")
            // physicallyHand &&
            // physicallyHand.includes &&
            // physicallyHand.includes(1)
          ) {
            // if (client.addCategory === "category_1") {
            //   setCapital22("25%");
            //   setInterestRest22(`${7 + 1}%`);
            //   setYearOfExpension22("5 Year");
            // } else if (client.addCategory === "category_2") {
            //   setCapital22("20%");
            //   setInterestRest22(`${6 + 1}%`);
            //   setYearOfExpension22("5 Year");
            // } else if (client.addCategory === "category_3") {
              setInterestRest22(`${5 + 1}%`);
              setYearOfExpension22("5 Year");
              // setCapital22("10%");
            // }
          } else {
            // if (client.addCategory === "category_1") {
            //   setCapital22("25%");
            //   setInterestRest22("7%");
            //   setYearOfExpension22("5 Year");
            // } else if (client.addCategory === "category_2") {
            //   setInterestRest22("6%");
            //   setCapital22("20%");
            //   setYearOfExpension22("5 Year");
            // } else if (client.addCategory === "category_3") {
              setInterestRest22("5%");
            //   setCapital22("10%");
              setYearOfExpension22("5 Year");
            // }
          }
        });
      if (companySize === "micro") {
        console.log("client.addCategory", client.addCategory);
        console.log("addCategory", addCategory);
            if (client.addCategory === "category_1" || addCategory === "category_1") {
              setCapital22("30%");
              // setInterestRest22(`${7 + 1}%`);
              // setYearOfExpension22("5 Year");
            } else if (client.addCategory === "category_2" || addCategory === "category_2") {
              setCapital22("20%");
              // setInterestRest22(`${6 + 1}%`);
              // setYearOfExpension22("5 Year");
            } else if (client.addCategory === "category_3" || addCategory === "category_3") {
              setCapital22("10%");
              // setInterestRest22(`${5 + 1}%`);
              // setYearOfExpension22("5 Year");
            }
      }
    }
  }, [client, project, years, owner, companySize, addCategory]);

  useEffect(() => {
    const createPolicy = async (postData, year) => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/create-policy`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("signIn")}`,
            },
          }
        );
        if (response.status === 201) {
          getPolicyData();
        }
      } catch (error) {
        console.error(`Error creating policy for ${year}:`, error);
      }
    };

    if (apply19 === 0 && policy2019Id === undefined) {
      const postData = {
        year: 2019,
        cgtmse: cgtmse19,
        sgst: sgst19,
        epf: epf19,
        apply: apply19,
        projectId: projectId || state?.projectId,
      };

      const shouldCallApi =
        (state === null && location.state === null) ||
        policy2019Id === undefined;

      if (shouldCallApi) {
        const timerId = setTimeout(() => {
          createPolicy(postData, 2019);
        }, 1000);

        return () => clearTimeout(timerId);
      }
    }
    if (apply20 === 0 && policy2020Id === undefined) {
      const postData = {
        year: 2020,
        cgtmse: cgtmse20,
        sgst: sgst20,
        epf: epf20,
        apply: apply20,
        projectId: projectId || state?.projectId,
      };

      const shouldCallApi =
        (state === null && location.state === null) ||
        policy2020Id === undefined;

      if (shouldCallApi) {
        const timerId = setTimeout(() => {
          createPolicy(postData, 2020);
        }, 1000);

        return () => clearTimeout(timerId);
      }
    }

    if (apply22 === 0 && policy2022Id === undefined) {
      const postData = {
        year: 2022,
        cgtmse: cgtmse22,
        sgst: sgst22,
        epf: epf22,
        apply: apply22,
        projectId: projectId || state?.projectId,
        capital: costProject <= 10000000 ? addCategory == "category_1" ? '30%' : addCategory == "category_2" ? '20%' : '10%' : ''
      };

      const shouldCallApi =
        (state === null && location.state === null) ||
        policy2022Id === undefined;

      if (shouldCallApi) {
        const timerId = setTimeout(() => {
          createPolicy(postData, 2022);
        }, 1000);

        return () => clearTimeout(timerId);
      }
    }
  }, [policy2020Id, policy2019Id, policy2022Id]);

  return (
    <div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="container card card-body">
          <div>
            <h2>Policy</h2>
          </div>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th rowSpan="2"></th>
                  <th rowSpan="2" colSpan="2" className="text-center">
                    Eligible
                  </th>
                  <th rowSpan="2" colSpan="2" className="text-center">
                    Interest Subsidy
                  </th>
                  <th rowSpan="2" colSpan="1" className="text-center">
                    Capital Subsidy
                  </th>
                  <th rowSpan="2" colSpan="2" className="text-center">
                    Power
                  </th>
                  <th colSpan="3" className="text-center">
                    Other
                  </th>
                  <th rowSpan="2" colSpan="2" className="text-center">
                    Apply
                  </th>
                </tr>
                <tr>
                  <th>CGTMSE</th>
                  <th>SGST</th>
                  <th>EPF</th>
                </tr>
              </thead>
              <tbody>
                {years.map((year) => (
                  <tr key={year}>
                    <th>{year}</th>
                    <td>
                      {year === 2019
                        ? elegible
                        : year === 2020
                        ? elegible20
                        : year === 2022
                        ? elegible22
                        : ""}
                    </td>
                    <td>
                      {year === 2019
                        ? yearOfExpension
                        : year === 2020
                        ? yearOfExpension20
                        : year === 2022
                        ? yearOfExpension22
                        : ""}
                    </td>
                    <td>
                      {year === 2019
                        ? interestRate
                        : year === 2020
                        ? interestRate20
                        : year === 2022
                        ? interestRate22
                        : ""}
                    </td>
                    <td>
                      {year === 2019
                        ? yearOfExpension
                        : year === 2020
                        ? yearOfExpension20
                        : year === 2022
                        ? companySize === "large"
                          ? displayYear
                          : yearOfExpension22
                        : ""}
                    </td>
                    <td>
                      {year === 2019
                        ? capital
                        : year === 2020
                        ? capital20
                        : year === 2022
                        ? capital22
                        : ""}
                    </td>
                    {/* <td>
                      {year === 2019
                        ? capital
                        : year === 2020
                        ? yearOfExpension20
                        : year === 2022
                        ? yearOfExpension22
                        : ""}
                    </td> */}
                    <td>
                      {year === 2019
                        ? unit
                        : year === 2020
                        ? unit20
                        : year === 2022
                        ? ""
                        : ""}
                    </td>
                    <td>
                      {year === 2019
                        ? yearOfExpension
                        : year === 2020
                        ? ""
                        : year === 2022
                        ? ""
                        : ""}
                    </td>
                    {year === 2019 && (
                      <>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            lineHeight: "0",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="applyCheckbox"
                            className="form-check-input"
                            style={{ margin: "-8px" }}
                            checked={cgtmse19 === 1}
                            onChange={(e) => handleChange(e, "cgtmse19")}
                          />
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            lineHeight: "0",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="applyCheckbox"
                            className="form-check-input"
                            style={{ margin: "-8px" }}
                            checked={sgst19 === 1}
                            onChange={(e) => handleChange(e, "sgst19")}
                          />
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            lineHeight: "0",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="applyCheckbox"
                            className="form-check-input"
                            style={{ margin: "-8px" }}
                            checked={epf19 === 1}
                            onChange={(e) => handleChange(e, "epf19")}
                          />
                        </td>
                      </>
                    )}
                    {year === 2020 && (
                      <>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            lineHeight: "0",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="applyCheckbox"
                            className="form-check-input"
                            style={{ margin: "-8px" }}
                            checked={cgtmse20 === 1}
                            onChange={(e) => handleChange(e, "cgtmse20")}
                          />
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            lineHeight: "0",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="applyCheckbox"
                            className="form-check-input"
                            style={{ margin: "-8px" }}
                            checked={sgst20 === 1}
                            onChange={(e) => handleChange(e, "sgst20")}
                          />
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            lineHeight: "0",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="applyCheckbox"
                            className="form-check-input"
                            style={{ margin: "-8px" }}
                            checked={epf20 === 1}
                            onChange={(e) => handleChange(e, "epf20")}
                          />
                        </td>
                      </>
                    )}
                    {year === 2022 && (
                      <>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            lineHeight: "0",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="applyCheckbox"
                            className="form-check-input"
                            style={{ margin: "-8px" }}
                            checked={cgtmse22 === 1}
                            onChange={(e) => handleChange(e, "cgtmse22")}
                          />
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            lineHeight: "0",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="applyCheckbox"
                            className="form-check-input"
                            style={{ margin: "-8px" }}
                            checked={sgst22 === 1}
                            onChange={(e) => handleChange(e, "sgst22")}
                          />
                        </td>
                        <td
                          style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            lineHeight: "0",
                          }}
                        >
                          <input
                            type="checkbox"
                            id="applyCheckbox"
                            className="form-check-input"
                            style={{ margin: "-8px" }}
                            checked={epf22 === 1}
                            onChange={(e) => handleChange(e, "epf22")}
                          />
                        </td>
                      </>
                    )}
                    {year === 2019 && (
                      <td
                        style={{
                          textAlign: "center",
                          verticalAlign: "middle",
                          lineHeight: "0",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="applyCheckbox"
                          className="form-check-input"
                          style={{ margin: "-8px" }}
                          checked={apply19 === 1}
                          onChange={(e) => handleChange(e, "apply19")}
                        />
                      </td>
                    )}
                    {year === 2020 && (
                      <td
                        style={{
                          textAlign: "center",
                          verticalAlign: "middle",
                          lineHeight: "0",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="applyCheckbox"
                          className="form-check-input"
                          style={{ margin: "-8px" }}
                          checked={apply20 === 1}
                          onChange={(e) => handleChange(e, "apply20")}
                        />
                      </td>
                    )}
                    {year === 2022 && (
                      <td
                        style={{
                          textAlign: "center",
                          verticalAlign: "middle",
                          lineHeight: "0",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="applyCheckbox"
                          className="form-check-input"
                          style={{ margin: "-8px" }}
                          checked={apply22 === 1}
                          onChange={(e) => handleChange(e, "apply22")}
                        />
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-grid gap-2 d-md-flex justify-content-md-end">
            <div className="form-group text-center">
              <button
                type="button"
                style={{ border: "1px solid gray", marginRight: "10px" }}
                className="btn btn-default btn res-btn-gray"
                onClick={() => handleBack()}
              >
                Previous
              </button>
              <button
                type="button"
                style={{ border: "1px solid gray" }}
                className="btn btn-default col-xs-offset-1"
                onClick={handleNext}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Policy;
